// removed by extract-text-webpack-plugin
module.exports = {"main":"ExistingSegmentTooltip-main--hoGHb","segment":"ExistingSegmentTooltip-segment--3gVqe","segmentIcon":"ExistingSegmentTooltip-segmentIcon--yNqAG","segmentName":"ExistingSegmentTooltip-segmentName--Y5r8L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateSegment/ExistingSegmentTooltip/ExistingSegmentTooltip.scss
// module id = vRF7
// module chunks = 4